/** @jsx jsx */
import { jsx, Flex, Box } from "theme-ui"

const PageIntro = ({ children, align = 'center' }) => (
  <Flex
    sx={{
      position: 'relative',
      zIndex: 10,
      mt: ['-7.5vh', '-15vh'],
    }}>
    <Box
      sx={{
        bg: 'rgba(255,255,255,1)',
        width: ['2/3'],
        mx: 'auto',
        py: 4,
        px: [3, 5],
        borderTop: theme => `8px solid ${theme.colors.primary}`,
        textAlign: `${align}` 
      }}>
        { children }
    </Box>
  </Flex>
)

export default PageIntro